import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PhoneDisplay } from "@/components/PhoneDisplay";
import { Label } from "@/components/ui/label";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";

// Selettore cliente riutilizzabile: carica l'elenco clienti e richiama onPick(cliente, id)
// così i vari flussi di vendita possono precompilare anagrafica e indirizzo.
export function CustomerPicker({
  value,
  onPick,
  label = "Cliente registrato (opzionale)",
  placeholder = "Seleziona un cliente salvato",
  testid = "customer-picker",
}) {
  const [customers, setCustomers] = useState([]);
  useEffect(() => { api.get("/customers").then((r) => setCustomers(r.data || [])).catch(() => {}); }, []);
  const handle = (id) => { const c = customers.find((x) => x.id === id); if (c) onPick(c, id); };
  return (
    <div>
      <Label>{label}</Label>
      <Select value={value || ""} onValueChange={handle}>
        <SelectTrigger className="mt-1.5" data-testid={testid}><SelectValue placeholder={placeholder} /></SelectTrigger>
        <SelectContent>
          {customers.map((c) => (
            <SelectItem key={c.id} value={c.id}>
              {(c.company_name || c.name || c.nome)}{c.vat_number ? ` · P.IVA ${c.vat_number}` : ""}{c.email ? ` — ${c.email}` : c.phone ? <> — <PhoneDisplay value={c.phone} data-testid={`${testid}-phone-${c.id}`} /></> : ""}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
